import { createAction } from '@reduxjs/toolkit'

import { CustomerAgreement } from 'types/GlobalCustomerAgreement'

// tryCreateCustomerAgreement
export const create = createAction('create_customer_agreement')
export const createSuccess = createAction<CustomerAgreement>(
  'create_customer_agreement_success'
)
export const createFailed = createAction('create_customer_agreement_failed')

// tryGetCustomerAgreements
export const getAll = createAction('get_customer_agreements')
export const getAllSuccess = createAction<{
  customerId: string
  agreements: CustomerAgreement[]
}>('get_customer_agreements_success')
export const getAllFailed = createAction('get_customer_agreements_failed')

// tryUpdatCustomerAgreement
export const update = createAction('update_customer_agreement')
export const updateSuccess = createAction<CustomerAgreement>(
  'update_customer_agreement_success'
)
export const updateFailed = createAction('update_customer_agreement_failed')

// tryDeleteCustomerAgreement
export const destroy = createAction('destroy_customer_agreement')
export const destroySuccess = createAction<{
  customerId: string
  agreementId: string
}>('destroy_customer_agreement_success')
export const destroyFailed = createAction('destroy_customer_agreement_failed')
